import React from 'react'

export default function Quote({ className }) {
  return (
    <svg viewBox="0 0 20 20" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M10 0C4.477 0 0 4.477 0 10s4.477 9.999 10 9.999h8.175a1.823 1.823 0 001.824-1.824V10c0-5.523-4.477-10-9.999-10zM5.833 5.833h7.5a.833.833 0 010 1.667h-7.5a.833.833 0 010-1.667zM5 10c0-.46.373-.834.833-.834H12.5a.834.834 0 010 1.667H5.833A.833.833 0 015 10zm9.166 4.166H7.5a.833.833 0 010-1.666h6.666a.834.834 0 110 1.666z"
      />
    </svg>
  )
}
